import {
  Component,
  Inject,
  inject,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogModule,
  MatDialogRef,
  MatDialogTitle,
} from "@angular/material/dialog";

export interface ConfirmDialogData {
  title?: string;
  message?: string;
  okText?: string;
  cancelText?: string;
}

@Component({
  selector: "app-dialog-animation",
  imports: [
    MatButtonModule,
    MatDialogActions,

    MatDialogTitle,
    MatDialogContent,
  ],
  templateUrl: "./dialog-animation.component.html",
  styleUrl: "./dialog-animation.component.css",
})
export class DialogAnimationComponent {
  readonly dialogRef = inject(MatDialogRef<DialogAnimationComponent>);
  public data: ConfirmDialogData = inject<ConfirmDialogData>(MAT_DIALOG_DATA);
  constructor() {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onOk(): void {
    // You can do any in-dialog validation or logic here
    this.dialogRef.close(true); // return a value to the caller
  }
}
